import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getTagsData } from 'models/tagsdata'; // Importing function to get tags data

/**
 * TagsView class extends JetView to create a view for displaying awarded badges.
 */
export default class TagsView extends JetView {
    /**
     * Configures the layout of the TagsView.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Awarded Badges'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view for displaying data
                    type: 'barH', // Horizontal bar chart type
                    localId: 'chart', // Local ID for referencing the chart
                    radius: 0, // No rounded corners for bars
                    barWidth: 20, // Width of the bars
                    value: '#number#', // Field for bar value
                    border: false, // No border around bars
                    padding: {
                        // Padding around the chart
                        top: 0,
                        left: 20,
                        bottom: 40,
                    },
                    xAxis: {
                        // Configuration for the X-axis
                        start: 0, // Starting value
                        end: 32, // Ending value
                        step: 4, // Step size
                        color: '#fff', // Color of the axis labels
                        lineColor: '#EDEFF0', // Color of the axis line
                    },
                    yAxis: {
                        // Configuration for the Y-axis
                        template: '', // Template for Y-axis labels
                        lines: false, // No lines on the Y-axis
                        color: '#EDEFF0', // Color of the Y-axis
                    },
                    color: '#color#', // Field for bar color
                    legend: {
                        // Configuration for the chart legend
                        template: (obj) => _(obj.tag), // Localized legend template
                        valign: 'middle', // Vertical alignment
                        align: 'right', // Horizontal alignment
                        width: 130, // Width of the legend
                        marker: {
                            // Marker configuration for legend items
                            type: 'round', // Round marker type
                            width: 7, // Width of the marker
                            height: 8, // Height of the marker
                        },
                    },
                    tooltip: {
                        // Tooltip configuration for chart bars
                        template: '#number# clients', // Template for tooltip text
                    },
                },
            ],
        };
    }

    /**
     * Initializes the TagsView.
     */
    init() {}
}

// FILE DOCUMENTED
